<div class="tag-input-wrapper" [class]="styleClass" [class.disabled]="disabled">
  <div class="tag-input-container" [class.tag-input-container--error]="styleClass?.includes('tag-input--error')">
    <input
      type="text"
      class="tag-input"
      [placeholder]="placeholder"
      [(ngModel)]="tagInput"
      [ngModelOptions]="{standalone: true}"
      [disabled]="disabled"
      (keydown)="onTagInputKeydown($event)"
      (input)="onTagInputChange()"
      (paste)="onTagInputPaste($event)"
    />
    <button
      type="button"
      class="tag-add-button"
      (click)="addTag()"
      [disabled]="!canAddTag() || (maxTags !== null && tags.length >= maxTags) || isInputDuplicate()"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
  <div class="tags-container" *ngIf="tags.length > 0">
    <span
      *ngFor="let tag of tags; trackBy: trackByTag"
      class="tag-chip"
      [class.tag-chip--duplicate]="isTagDuplicate(tag)"
    >
      {{ tag }}
      <svg
        class="tag-chip-close"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        (click)="removeTag(tag)"
        *ngIf="!disabled"
      >
        <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  </div>
</div>
